import * as Types from "../constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCH_DUMMY:
      return {
        ...state,
        ...action.payload.dummyList,
      };
    default:
      return state;
  }
};
